/**
 * A calendar day as the patient reads it, in the language they chose in the
 * app: "1 sept 2026" in Spanish, "Sep 1, 2026" in English. A bare
 * `toLocaleDateString()` follows the browser instead, so a patient who picked
 * Spanish on an English phone read their dates in English.
 */
export function formatDay(iso: string, language: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(language, {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(date);
}
